import { Col, PageHeader } from 'antd';
import {
  LeftCol,
  MainContainer,
} from 'app/components/LayoutComponents/LayoutComponents';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuInfo } from 'types';
import SettingsTabs from '../../parts/SettingsTabs/SettingsTabs';
import TaskCategoriesSettingsCard from '../../parts/TaskCategorySettingsCard/TaskCategorySettingsCard';
import { SettingsTabKeyType } from '../../types';

interface IProps {}

const SettingsPage: FC<IProps> = () => {
  const { t } = useTranslation();

  const [selectedKey, setSelectedKey] = useState<SettingsTabKeyType>(
    'taskCategories',
  );

  const onClickMenu = (clickedItem: MenuInfo) => {
    const key = clickedItem.key as SettingsTabKeyType;
    setSelectedKey(key);
  };

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Settings.Title', 'Settings')}
      />
      <MainContainer>
        <LeftCol>
          <SettingsTabs onClickMenu={onClickMenu} selectedKey={selectedKey} />
        </LeftCol>
        <Col flex={1}>
          <TaskCategoriesSettingsCard />
        </Col>
      </MainContainer>
    </>
  );
};

export default SettingsPage;
